/// <amd-module name="Pipeline/Analytics/PipelineOutcome/PassRateTrendCard/Stores/PipelineOutcomePassRateTrendStore" />
import { IPipelineReportBaseState, PipelineReportBaseStore } from "Pipeline/Analytics/Common/Stores/PipelineReportBaseStore";
import { IPipelineOutcomeData } from "Pipeline/Analytics/Common/Types";
import { PipelineOutcomePassRateTrendActions } from "Pipeline/Analytics/PipelineOutcome/PassRateTrendCard/Actions/PipelineOutcomePassRateTrendActions";

export interface IPipelineOutcomePassRateTrendState extends IPipelineReportBaseState<IPipelineOutcomeData> {}

export class PipelineOutcomePassRateTrendStore extends PipelineReportBaseStore<
    PipelineOutcomePassRateTrendActions,
    IPipelineOutcomePassRateTrendState,
    IPipelineOutcomeData
> {}
